import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import Policy from '../pages/Policy.vue'
import Submit from '../pages/Submit.vue'
import Advisories from '../pages/Advisories.vue'
import AdvisoryDetail from '../pages/AdvisoryDetail.vue'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/policy', name: 'policy', component: Policy },
    { path: '/submit', name: 'submit', component: Submit },
    { path: '/advisories', name: 'advisories', component: Advisories },
    { path: '/advisories/:id', name: 'advisory-detail', component: AdvisoryDetail, props: true }
  ]
})
